import { render, staticRenderFns } from "./PlatformProductTables.vue?vue&type=template&id=2a6abc08&"
import script from "./PlatformProductTables.vue?vue&type=script&lang=js&"
export * from "./PlatformProductTables.vue?vue&type=script&lang=js&"
import style0 from "./PlatformProductTables.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports